export default "__VITE_ASSET__DjGEyKll__"